import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Alert, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import { fail_retrieve_ready_for_dispatch_settings, loading_retrieve_ready_for_dispatch_settings, reset_retrieve_ready_for_dispatch_settings, success_retrieve_ready_for_dispatch_settings } from '../../reducers/auth_tenant/retrieve_ready_for_dispatch_settings_Slice';
import { DELETE_EMPLOYEE_FROM_READY_FOR_DISPATCH_SETTING_ERROR_MSG, DELETE_EMPLOYEE_FROM_READY_FOR_DISPATCH_SETTING_SUCCESS_MSG, RETRIEVE_READY_FOR_DISPATCH_SETTING_ERROR_MSG, RETRIEVE_READY_FOR_DISPATCH_SETTING_SUCCESS_MSG, UPDATE_READY_FOR_DISPATCH_SETTING_ERROR_MSG, UPDATE_READY_FOR_DISPATCH_SETTING_SUCCESS_MSG } from '../../utils/error_success_messages';
import { getSelectedOption, messageToast } from '../../utils/Utils';
import { useSelector } from 'react-redux';
import * as app_consts from "../../utils/app_consts";
import { DELETE_EMPLOYEE_FROM_READY_FOR_DISPATCH_NOTIFICATIONS_API, RETRIEVE_TENANT_READY_FOR_DISPATCH_SETTINGS_API, TENANT_UPDATE_READY_FOR_DISPATCH_SETTINGS_API } from '../../api/api_data';
import { Block, Button, Col, DataTableHead, DataTableItem, DataTableRow, Icon, Row, RSelect } from '../Component';
import { fail_update_ready_for_dispatch_settings, loading_update_ready_for_dispatch_settings, reset_update_ready_for_dispatch_settings, success_update_ready_for_dispatch_settings } from '../../reducers/auth_tenant/update_ready_for_dispatch_settings_Slice';
import { fail_delete_employee_from_ready_for_disaptch_Settings, loading_delete_employee_from_ready_for_disaptch_Settings, reset_delete_employee_from_ready_for_disaptch_Settings, success_delete_employee_from_ready_for_disaptch_Settings } from '../../reducers/auth_tenant/delete_employee_from_ready_for_disaptch_Settings_Slice';
import YesNoModal from './YesNoModal';

const initial_state = { profile_id: "" };

const ViewDispatchNotificationsModal = ({ isOpen, closeModal, tenant_info, user_info, successFunction }) => {

  const [page_data, setPageData] = useState([]);
  const [open, setOpen] = useState(isOpen);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const [formData, setFormData] = useState(initial_state);
  const [employees, setEmployees] = useState([]);

  const [update_loading, setUpdateLoading] = useState(false);
  const [update_error, setUpdateError] = useState("");
  const [delete_modal, setDeleteModal] = useState(false);
  const [selected_delete, setSelectedDelete] = useState("");
  const [delete_error, setDeleteError] = useState("");

  useEffect(() => {
    if (isOpen)
    {
      setFormData(initial_state);
      // Dispatch
      retrieve_dispatch_notifications_settings();
    }
    setOpen(isOpen);
  }, [isOpen]);

  const retrieve_dispatch_notifications_settings = () => {
    dispatch(tenant_auth_actions_helper(loading_retrieve_ready_for_dispatch_settings, success_retrieve_ready_for_dispatch_settings, fail_retrieve_ready_for_dispatch_settings, RETRIEVE_READY_FOR_DISPATCH_SETTING_ERROR_MSG, RETRIEVE_READY_FOR_DISPATCH_SETTING_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_READY_FOR_DISPATCH_SETTINGS_API}`));
  };

  // Listener
  const retrieve_ready_for_dispatch_settings_listener = useSelector((state) => state.retrieve_ready_for_dispatch_settings.retrieve_ready_for_dispatch_settings);

  useEffect(() => {
    if (retrieve_ready_for_dispatch_settings_listener.status !== app_consts.IDLE)
    {
      if (retrieve_ready_for_dispatch_settings_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_ready_for_dispatch_settings_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(retrieve_ready_for_dispatch_settings_listener.message);
          messageToast(retrieve_ready_for_dispatch_settings_listener.message, app_consts.FAIL);
        } else if (retrieve_ready_for_dispatch_settings_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_ready_for_dispatch_settings_listener.data);

          const emp_data = retrieve_ready_for_dispatch_settings_listener.data?.employees?.map((emp) => {
            return (
              {
                ...emp,
                label: `${emp?.user?.first_name} ${emp?.user?.last_name} - ${emp?.account?.mobile_number}`,
                value: emp?.profile?.id
              }
            );
          });

          setEmployees(emp_data);

          const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);

          return () => clearTimeout(timer); // cleanup in case the component unmounts

        }
        dispatch(reset_retrieve_ready_for_dispatch_settings());
      }
    }
  }, [retrieve_ready_for_dispatch_settings_listener]);

  const handleAddDispatch = () => {
    setUpdateError("");
    dispatch(tenant_auth_actions_helper(loading_update_ready_for_dispatch_settings, success_update_ready_for_dispatch_settings, fail_update_ready_for_dispatch_settings, UPDATE_READY_FOR_DISPATCH_SETTING_ERROR_MSG, UPDATE_READY_FOR_DISPATCH_SETTING_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_UPDATE_READY_FOR_DISPATCH_SETTINGS_API}`, formData));
  };

  // Listener
  const update_ready_for_dispatch_settings_listener = useSelector((state) => state.update_ready_for_dispatch_settings.update_ready_for_dispatch_settings);

  useEffect(() => {
    if (update_ready_for_dispatch_settings_listener.status !== app_consts.IDLE)
    {
      if (update_ready_for_dispatch_settings_listener.status === app_consts.LOADING)
      {
        setUpdateLoading(true);
        setUpdateError("");
      } else
      {
        setUpdateLoading(false);
        if (update_ready_for_dispatch_settings_listener.status === app_consts.FAIL)
        {
          setUpdateError(update_ready_for_dispatch_settings_listener.message);
          messageToast(update_ready_for_dispatch_settings_listener.message, app_consts.FAIL);
        } else if (update_ready_for_dispatch_settings_listener.status === app_consts.SUCCESS)
        {
          messageToast(UPDATE_READY_FOR_DISPATCH_SETTING_SUCCESS_MSG, app_consts.SUCCESS);
          successFunction();
          retrieve_dispatch_notifications_settings();
          setFormData(initial_state);
        }
        dispatch(reset_update_ready_for_dispatch_settings());
      }
    }
  }, [update_ready_for_dispatch_settings_listener]);

  const open_delete_modal = (delete_item) => {
    setDeleteModal(true);
    setSelectedDelete(delete_item);
  };

  const close_delete_modal = () => {
    setDeleteModal(false);
    setSelectedDelete("");
  };

  const handle_delete_employee = () => {
    setDeleteError("");
    dispatch(tenant_auth_actions_helper(loading_delete_employee_from_ready_for_disaptch_Settings, success_delete_employee_from_ready_for_disaptch_Settings, fail_delete_employee_from_ready_for_disaptch_Settings, DELETE_EMPLOYEE_FROM_READY_FOR_DISPATCH_SETTING_ERROR_MSG, DELETE_EMPLOYEE_FROM_READY_FOR_DISPATCH_SETTING_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${DELETE_EMPLOYEE_FROM_READY_FOR_DISPATCH_NOTIFICATIONS_API}`, { profile_id: selected_delete?.id }));
  };

  // Listener
  const delete_employee_from_ready_for_disaptch_Settings_listener = useSelector((state) => state.delete_employee_from_ready_for_disaptch_Settings.delete_employee_from_ready_for_disaptch_Settings);

  useEffect(() => {
    if (delete_employee_from_ready_for_disaptch_Settings_listener.status !== app_consts.IDLE)
    {
      if (delete_employee_from_ready_for_disaptch_Settings_listener.status === app_consts.LOADING)
      {
        setDeleteError("");
      } else
      {
        setDeleteError("");
        if (delete_employee_from_ready_for_disaptch_Settings_listener.status === app_consts.FAIL)
        {
          setUpdateError(delete_employee_from_ready_for_disaptch_Settings_listener.message);
          messageToast(delete_employee_from_ready_for_disaptch_Settings_listener.message, app_consts.FAIL);
        } else if (delete_employee_from_ready_for_disaptch_Settings_listener.status === app_consts.SUCCESS)
        {
          messageToast(DELETE_EMPLOYEE_FROM_READY_FOR_DISPATCH_SETTING_SUCCESS_MSG, app_consts.SUCCESS);
          successFunction();
          retrieve_dispatch_notifications_settings();
          setSelectedDelete("");
        }
        dispatch(reset_delete_employee_from_ready_for_disaptch_Settings());
      }
    }
  }, [delete_employee_from_ready_for_disaptch_Settings_listener]);

  return (
    <>
      <Modal isOpen={open} toggle={update_loading || loading ? "" : closeModal} className="modal-dialog-centered" size={"lg "}>
        <ModalHeader toggle={update_loading || loading ? "" : closeModal}>Ready for DIspatch Notifications</ModalHeader>
        <ModalBody>
          {
            loading ?
              <>
                <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                  <div className="text-soft fw-bold" style={{ fontSize: 18, marginTop: "90px" }}>Retrieveing Ready for Dispatch Settings...</div>
                  <div className="nk-loader mt-2  w-70 m-auto "></div>
                </div>
              </>
              :
              <>
                {
                  error ?
                    <>
                      <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                        <div className="text-soft fw-bold" style={{ fontSize: 18, marginTop: "90px" }}>{error}</div>
                      </div>
                    </>
                    :
                    <>
                      <Row className="g-4">
                        {update_error && (
                          <div className="mb-3 w-100">
                            <Alert color="danger" className="alert-icon">
                              <Icon name="alert-circle" /> {update_error}{" "}
                            </Alert>
                          </div>
                        )}
                        <Col lg={6}>
                          <div className="form-group">
                            <div className="w-100">
                              <RSelect
                                options={employees}
                                className="w-100"
                                placeholder="Search"
                                value={getSelectedOption(formData?.profile_id, employees)}
                                onChange={(e) => setFormData({ ...formData, profile_id: e?.value })}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col lg="4" className="d-flex justify-content-start">
                          <Button onClick={handleAddDispatch} disabled={
                            (update_loading) ||
                            !(formData?.profile_id)
                          } color="primary">
                            {update_loading ? <Spinner size="sm" color="light" /> : "Add"}
                          </Button>
                        </Col>
                      </Row>
                      <Block>
                        <div className="nk-tb-list is-separate is-medium my-4">
                          <DataTableHead className="nk-tb-item">
                            <DataTableRow>
                              <span className="sub-text">Name</span>
                            </DataTableRow>
                            <DataTableRow>
                              <span className="sub-text">Email Address</span>
                            </DataTableRow>
                            <DataTableRow>
                              <span className="sub-text">Phone Number</span>
                            </DataTableRow>
                            <DataTableRow>
                              <span className="sub-text"></span>
                            </DataTableRow>
                          </DataTableHead>
                          {page_data?.settings && page_data?.settings.length > 0
                            ? page_data?.settings?.map((item) => (
                              <DataTableItem key={item.id}>
                                <DataTableRow>
                                  <div className="user-card">
                                    <div className="user-info">
                                      <span className="tb-lead">
                                        {item?.name || "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                      </span>
                                    </div>
                                  </div>
                                </DataTableRow>
                                <DataTableRow>
                                  <div className="user-card">
                                    <div className="user-info">
                                      <span className="tb-lead">
                                        {item?.email_address || "--"}
                                      </span>
                                    </div>
                                  </div>
                                </DataTableRow>
                                <DataTableRow>
                                  <span className="tb-odr-date">{item?.mobile_number || "--"}</span>
                                </DataTableRow>
                                <DataTableRow>
                                  <Icon name="trash-fill" className="text-danger" style={{ fontSize: "22px", cursor: "pointer" }} onClick={() => open_delete_modal(item)}></Icon>
                                </DataTableRow>
                              </DataTableItem>
                            ))
                            : <div className="ms-2">No Employees found</div>}
                        </div>
                      </Block>

                      <YesNoModal openModal={delete_modal} setOpenModal={setDeleteModal} modalTitle={`Remove Employee ${selected_delete && (`${selected_delete?.name} `)} ?`} errAmend={delete_error} setErrAmend={setDeleteError} buttonCancel="No" buttonConfirm="Yes" modalDescription={`Are you Sure that you want to Delete ${selected_delete && (`${selected_delete?.name}`)} from Ready for Dispatch Notifications List?`} succFunc={handle_delete_employee} />
                    </>
                }
              </>
          }
        </ModalBody>
      </Modal>
    </>
  );
};

export default ViewDispatchNotificationsModal;